export default __webpack_public_path__ + "e03d3b4c15ec4879a687779ef1a50e4c.png";